import React, { memo, useCallback, useMemo } from 'react';
import { API_DRUGS } from 'services/drug';
import { useSource } from 'AurionCR/components';
import { InputAdornment, TextField } from '@mui/material';
import { Autocomplete } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import style from './index.module.scss';
import { useTranslate } from 'hooks/use-translate';
import { generateDynamicQuery } from 'utils/service';

const useSourceDrugs = () => {
  const params = useMemo(
    () =>
      generateDynamicQuery({
        select: [
          'id',
          'catalogName',
          'drugNameEng',
          'defaultDosageForm',
          'defaultDosageFormTotal',
          'defaultDosageFormTotalDesc',
          'defaultDosageFormDaily',
          'defaultInstructions',
        ].join(','),
        filter: 'isActive==true',
        orderBy: 'highlight desc, catalogName',
      }),
    [],
  );
  return useSource<Components.Schemas.Drug>(`${API_DRUGS.GET_ALL_DYNAMIC}?${params}`);
};

interface Props {
  onTasks: (val: any[]) => void;
}
export const SelectAddNewDrug = memo<Props>(({ onTasks }) => {
  const { t } = useTranslate();
  const { data, loading } = useSourceDrugs();

  const onChange = useCallback(
    (e: any, value: any) => {
      onTasks([['onHandle', { type: 'onSelectDrug', value }]]);
    },
    [onTasks],
  );

  return (
    <Autocomplete
      className={style.root}
      options={data}
      value={null}
      getOptionLabel={(item) => String(item.catalogName)}
      getOptionKey={(item) => String(item.id)}
      isOptionEqualToValue={(item, value) => item.id === value.id}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          size={'small'}
          placeholder={t('add-drug')}
          slotProps={{
            ...params.slotProps,

            input: {
              ...params.slotProps.input,
              startAdornment: (
                <InputAdornment position="start">
                  <AddIcon />
                </InputAdornment>
              ),
            },
          }}
        />
      )}
      loading={loading}
      fullWidth={true}
      onChange={onChange}
      slotProps={{
        popper: { placement: 'bottom-start' },
      }}
    />
  );
});
